import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

import { AppCommon } from '../../../../../providers/app-common';
import { SourcingNeedV2ViewModel } from '../../../../../models-views/sourcing-needs-v2.view.model';
import { StandardResponseModel } from '../../../../../models/project.model';

@Component({
  selector: 'app-sn-form-production-fabrication-v2',
  templateUrl: './sn-form-production-fabrication-v2.component.html',
  styleUrls: ['./sn-form-production-fabrication-v2.component.scss'],
  standalone: false
})
export class SnFormProductionFabricationV2Component implements OnInit, OnChanges {
  @Input() eventId: number | null = null;
  @Input() data: any;
  @Output() closeModal = new EventEmitter<'success' | 'cancel'>();

  form!: FormGroup;
  isEdit: boolean = true;
  isView: boolean = false;
  existingData: any = null;

  eventStructuresResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
  infrastructureResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
  liveStreamingHybridResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
  intercomCommunicationResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());

  private readonly arrayFields: string[] = [
    'event_structures',
    'infrastructure',
    'live_streaming_hybrid',
    'intercom_communication'
  ];

  constructor(
    private fb: FormBuilder,
    private vm: SourcingNeedV2ViewModel,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.vm.parentSnFormProductionFabricationV2Component = this;
    this.initForm();

    this.vm.subscribeToProductionFabricationModels(
      this.eventStructuresResponseModel,
      this.infrastructureResponseModel,
      this.liveStreamingHybridResponseModel,
      this.intercomCommunicationResponseModel
    );
    this.vm.initGeneralCallsForProductionFabrication();

    setTimeout(() => {
      this.handleInputData();
    }, 300);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
      this.handleInputData();
    }
  }

  handleInputData(): void {
    if (this.data) {
      this.existingData = this.data;
      this.isView = false;
      this.isEdit = true;
      this.form.patchValue(this.mapApiToForm(this.data));
    } else {
      this.existingData = null;
      this.isView = false;
      this.isEdit = true;
      this.form.reset();
      this.form.enable();
      this.cdr.detectChanges();
    }
  }

  mapApiToForm(data: any): any {
    return {
      event_structures: this.extractIds(data, 'event_structures'),
      infrastructure: this.extractIds(data, 'infrastructure'),
      live_streaming_hybrid: this.extractIds(data, 'live_streaming_hybrid'),
      intercom_communication: this.extractIds(data, 'intercom_communication')
    };
  }

  private extractIds(data: any, key: string): any[] {
    const directValue = data?.[key];
    if (Array.isArray(directValue)) {
      if (directValue.length > 0 && typeof directValue[0] === 'object') {
        return directValue.map((item: any) => item.id);
      }
      return directValue;
    }

    const detailsKey = `${key}_details`;
    if (Array.isArray(data?.[detailsKey])) {
      return data[detailsKey].map((item: any) => item.id);
    }

    return [];
  }

  initForm(): void {
    this.form = this.fb.group({
      event_structures: [[]],
      infrastructure: [[]],
      live_streaming_hybrid: [[]],
      intercom_communication: [[]]
    });
  }

  onSave(): void {
    if (!this.form.valid) {
      return;
    }

    const payload = this.normalizePayload(this.form.value);
    payload.sourcing_need = this.eventId;
    payload.is_production_fabrication_required = true;

    const loggedInUser = AppCommon.getloggedInObject();
    const userId = loggedInUser?.user?.id;

    if (this.isEdit && this.existingData) {
      payload.id = this.existingData.id;
      payload.modified_by = userId;
      this.vm.addUpdateProductionAndFabrication(payload, true);
    } else {
      payload.created_by = userId;
      this.vm.addUpdateProductionAndFabrication(payload, false);
    }
  }

  productionAndFabricationAdded(): void {
    this.closeModal.emit('success');

    if (this.eventId) {
      this.vm.getSouringNeedbyId(this.eventId, 'cet-sourcing-needs-v2');
    }
  }

  onEdit(): void {
    this.isEdit = true;
    this.isView = false;
    this.form.enable();
  }

  onCancel(): void {
    this.closeModal.emit('cancel');
  }

  private normalizePayload(payload: any): any {
    const normalizedPayload = { ...payload };

    this.arrayFields.forEach((field) => {
      normalizedPayload[field] = Array.isArray(normalizedPayload[field]) ? normalizedPayload[field] : [];
    });

    return normalizedPayload;
  }
}
